<template>
  <!-- 预览区内容 -->
  <div class="pswp img-enlarge" tabindex="-1" role="dialog" aria-hidden="true" :id="id">
    <!-- 仅在开启ocr且缩放等级为1时才显示ocr内容 -->
    <div v-if="ocr && gallery && gallery.getZoomLevel() == 1" class="img-ocr-block" :style="ocrBlockStyle">
      <div
        v-for="(item, i) in ocrChars"
        :key="i"
        class="img-ocr-p-item"
        :style="{
          left: item.location.left + 'px',
          top: item.location.top + 'px',
          // 通过高度-2px来确定文字的字体大小，直接使用高度作为字体大小的话会导致字体过大
          'font-size': item.location.height - 2 + 'px',
        }"
      >
        <span
          v-for="(chars, j) in item.chars"
          :key="j"
          class="img-ocr-item"
          :style="{
            'padding-left': chars.leftDiff + 'px',
            width: chars.location.width + 'px',
          }"
        >
          {{ chars.char }}
        </span>
      </div>
    </div>
    <div class="pswp__bg"></div>
    <div class="pswp__scroll-wrap">
      <div class="pswp__container">
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
      </div>
      <div class="pswp__ui pswp__ui--hidden">
        <div class="pswp__top-bar">
          <div class="pswp__counter"></div>
          <button class="pswp__button pswp__button--close" title="关闭图片"></button>
          <button class="pswp__button pswp__button--fs" title="切换全屏"></button>
          <button class="pswp__button pswp__button--zoom" title="缩放图片至原比例"></button>
          <button class="pswp__button pswp__button--rotate" title="旋转图片" @click="rotateImg">
            <ehf-icon icon="anticlockwise-2-line"></ehf-icon>
          </button>
          <button class="pswp__button pswp__button--outzoom" title="图片缩小" @click="zoom('out')"></button>
          <button class="pswp__button pswp__button--inzoom" title="图片放大" @click="zoom('in')"></button>
          <button class="pswp__button pswp__button--copy" title="复制表格" @click="copyTable()">复制表格</button>
          <div class="pswp__preloader">
            <div class="pswp__preloader__icn">
              <div class="pswp__preloader__cut">
                <div class="pswp__preloader__donut"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
          <div class="pswp__share-tooltip"></div>
        </div>
        <button class="pswp__button pswp__button--arrow--left" title="上一张"></button>
        <button class="pswp__button pswp__button--arrow--right" title="下一张"></button>
        <div class="pswp__caption">
          <div class="pswp__caption__center"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EhfImagePreview',
  }
</script>

<script setup>
  import PhotoSwipe from 'photoswipe'
  import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
  import 'photoswipe/dist/photoswipe.css'
  import 'photoswipe/dist/default-skin/default-skin.css'
  import { deepClone, isNull, local_set, local_today_get, copyHtml } from '../../utils'
  import { customAlphabet } from 'nanoid'
  import { ref, toRefs } from 'vue'
  import { imageOcrLocation } from '@/api/common'
  import { message } from 'ant-design-vue'
  const nanoid = customAlphabet('abcdefghijklmnopqrstuvwxyz', 10)

  const props = defineProps({
    ocr: {
      // 是否需要进行ocr识别
      type: Boolean,
      default: false,
    },
  })
  const { ocr } = toRefs(props)

  const id = ref('')
  id.value = nanoid()
  const gallery = ref(null)
  const ocrChars = ref([]) // 渲染的ocr结果数据
  const ocrBlockStyle = ref({})

  const initPhotoSwipeFromDOM = (selector, curImg, animation, ignoreDataSize) => {
    gallery.value = null
    var pswpElement = document.querySelector(`#${id.value}.img-enlarge.pswp`)
    var items = []
    var _index = 0
    const imgElList = document.querySelectorAll(selector)
    imgElList.forEach((item, index) => {
      if (item === curImg) {
        _index = index
      }
      // 计算图片实际大小并标记，以便插件读取
      ignoreDataSize !== true && item.setAttribute('data-size', item.naturalWidth + 'x' + item.naturalHeight)
      items.push({
        src: item.src,
        msrc: item.src,
        w: item.naturalWidth,
        h: item.naturalHeight,
        el: item,
      })
    })
    var options = {
      index: _index,
      history: false,
      mainClass: 'pswp--minimal--dark',
      barsSize: { top: 0, bottom: 0 },
      zoomEl: false,
      captionEl: false,
      fullscreenEl: true,
      shareEl: false,
      bgOpacity: 0.85,
      tapToToggleControls: false,
      tapToClose: true,
      closeOnScroll: false,
      maxSpreadZoom: 3,
      loop: false,
      pinchToClose: false,
      getThumbBoundsFn: isNull(animation)
        ? null
        : function (index) {
            // 开启和关闭时的过渡动画逻辑
            var thumbnail = items[index].el
            if (!thumbnail) {
              return
            }
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop
            var rect = thumbnail.getBoundingClientRect()
            // 判断是否需要开启动画
            if (animation === true || (typeof animation === 'function' && animation(thumbnail) === true)) {
              return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
            } else {
              return {}
            }
          },
      getDoubleTapZoom: function (isMouseClick, item) {
        // 双击放大
        if (isMouseClick) {
          return 1
        } else {
          return item.initialZoomLevel < 0.7 ? 1 : 2
        }
      },
    }
    gallery.value = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)
    // 读取图片数据时的回调
    gallery.value.listen('gettingData', function (index, item) {
      var linkEl = item.el
      if (!linkEl) {
        return
      }
      // 如果没有预先设定data-size则临时获取
      if (!linkEl.getAttribute('data-size') && ignoreDataSize != true) {
        var img = new Image()
        img.onload = function () {
          linkEl.setAttribute('data-size', img.naturalWidth + 'x' + img.naturalHeight)
          item.w = img.naturalWidth
          item.h = img.naturalHeight
          gallery.value.invalidateCurrItems()
          gallery.value.updateSize(true)
        }
        img.src = item.src
      }
    })
    gallery.value.listen('afterChange', function () {
      // 图片切换完成时，第一次打开时也会触发
      setTimeout(function () {
        // 延迟加载ocr内容，避免在预览动画过程中加载导致定位错乱
        initOcrInfo()
      }, 500)
    })
    gallery.value.listen('close', function () {
      // 关闭预览时清除所有选中
      window.getSelection().removeAllRanges()
    })
    gallery.value.init()
  }
  const rotateImg = () => {
    var imgEl = gallery.value.currItem.container.querySelector('.pswp__img:not(.pswp__img--placeholder)')
    if (!imgEl) {
      return
    }
    var curRotate = parseInt(imgEl.getAttribute('data-rotate') || 0)
    curRotate -= 90
    imgEl.style.transform = 'rotate(' + curRotate + 'deg)'
    imgEl.setAttribute('data-rotate', curRotate)
  }
  const zoom = (type) => {
    var curZoomLevel = gallery.value.getZoomLevel()
    var targetZoomLevel = curZoomLevel
    if (type == 'in') {
      if (curZoomLevel < 1) {
        targetZoomLevel = 1
      } else if (curZoomLevel >= 1 && curZoomLevel < 2) {
        targetZoomLevel = 2
      } else if (curZoomLevel >= 2) {
        targetZoomLevel = 3
      }
    } else if (type == 'out') {
      if (curZoomLevel > 1 && curZoomLevel <= 2) {
        targetZoomLevel = 1
      } else if (curZoomLevel > 2 && curZoomLevel <= 3) {
        targetZoomLevel = 2
      } else if (curZoomLevel > 3) {
        targetZoomLevel = 3
      }
    }
    gallery.value.zoomTo(targetZoomLevel, { x: gallery.value.viewportSize.x / 2, y: gallery.value.viewportSize.y / 2 }, 300)
  }
  // 初始化OCR内容
  const initOcrInfo = async () => {
    if (!props.ocr) return
    const currItem = gallery.value.currItem // 当前显示的图片
    const img_url = currItem.src
    const data = await getImageOcrInfo(img_url) // 根据链接获取ocr结果
    ocrChars.value = handleCharsInfo(data.words_result)
    const transform = currItem.container.style.transform // 获取当前显示图片的偏移量定位
    const transformArr = transform.match(/translate3d\(([^)]*)\)/)[1].split(',')
    ocrBlockStyle.value = {
      transform: 'translate(' + transformArr[0] + ', ' + transformArr[1] + ')',
    }
  }
  /**
   * 获取图片ocr内容
   * @param {String} url 图片链接
   * @param {Number} is_table 是否识别表格
   * @returns 返回识别结果，若没有则返回null
   */
  const getImageOcrInfo = async (url, is_table) => {
    // 优先从今日缓存中取
    let ocrRecord = local_today_get('image_ocr_record') || {}
    if (is_table == 1) {
      // 如果查的是表格，取表格缓存
      ocrRecord = local_today_get('table_ocr_record') || {}
    }
    if (ocrRecord[url]) {
      return ocrRecord[url]
    } else {
      // 没有缓存则请求接口获取
      const ret = await imageOcrLocation({ url, is_table })
      if (ret.code === 0) {
        // 存在ocr识别内容
        ocrRecord[url] = ret.data
        if (is_table == 1) {
          // 表格结果另外缓存进行区分
          local_set('table_ocr_record', JSON.stringify(ocrRecord))
        } else {
          local_set('image_ocr_record', JSON.stringify(ocrRecord))
        }
        return ret.data
      } else {
        message.error('ocr识别失败')
        return []
      }
    }
  }
  // 处理ocr结果数据
  const handleCharsInfo = (words_result) => {
    return words_result.map((words) => {
      let char = null
      words.chars.forEach((charInfo) => {
        if (char == null) {
          char = deepClone(charInfo)
          // 没有前一个，则与行的左边距进行比较计算间距
          charInfo.leftDiff = charInfo.location.left - words.location.left
        } else {
          // 计算与前一个字的间距
          const leftDiff = charInfo.location.left - (char.location.left + char.location.width)
          charInfo.leftDiff = leftDiff
          char = deepClone(charInfo)
        }
      })
      return words
    })
  }
  // 复制表格
  const copyTable = async () => {
    const currItem = gallery.value.currItem
    const img_url = currItem.src // 当前图片链接
    message.config({
      // 处理提示信息的渲染位置，避免被预览蒙层挡住
      getContainer: () => document.getElementById(id.value),
    })
    let hideLoading = null
    const timer = setTimeout(() => {
      // 增加loading
      hideLoading = message.loading('提取表格中...', 0)
    }, 100)
    const data = await getImageOcrInfo(img_url, 1)
    clearTimeout(timer)
    hideLoading && hideLoading() // 关闭loading
    if (data == null) {
      return message.error('ocr识别失败，请重试')
    }
    if (data.table_num > 0) {
      // 识别到表格数大于0
      const table_html = renderTableOcrData(data.tables_result)
      const success = copyHtml(table_html)
      if (success) {
        message.success('复制成功')
      }
    } else {
      message.info('该图片中未识别到表格')
    }
  }
  // 生成表格html内容
  const renderTableOcrData = (tables_result) => {
    const ret = []
    for (const tdata of tables_result) {
      ret.push('<table border="1">')
      if (tdata.header.length > 0) {
        // 处理表头内容
        ret.push('<thead>')
        ret.push(`<tr>${tdata.header.map((it) => `<th>${it.words}</th>`).join('')}</tr>`)
        ret.push('</thead>')
      }
      if (tdata.body.length > 0) {
        // 处理表格正文内容
        const rows = []
        for (const cell of tdata.body) {
          // 重新处理成二维数组
          rows[cell.row_start] = rows[cell.row_start] ?? []
          rows[cell.row_start][cell.col_start] = cell
        }
        ret.push('<tbody>')
        for (const row of rows) {
          ret.push('<tr>')
          for (const itc of row) {
            if (itc == null) continue
            const rowspan = itc.row_end - itc.row_start // 计算合并行数量
            const colspan = itc.col_end - itc.col_start // 计算合并列数量
            ret.push(
              '<td',
              // 处理合并单元格
              rowspan > 1 ? ` rowspan="${rowspan}"` : '',
              colspan > 1 ? ` colspan="${colspan}"` : '',
              `>${itc.words.replace(/\r\n|\r|\n/g, '<br>')}</td>`
            )
          }
          ret.push('</tr>')
        }
        ret.push('</tbody>')
      }
      if (tdata.footer.length > 0) {
        // 处理表尾内容
        ret.push('<tfoot>')
        ret.push(`<tr>${tdata.footer.map((it) => `<th>${it.words}</th>`).join('')}</tr>`)
        ret.push('</tfoot>')
      }
      ret.push('</table>')
    }
    return ret.join('')
  }

  defineExpose({
    initPhotoSwipeFromDOM,
  })
</script>

<style lang="scss" scoped>
  button.pswp__button--rotate {
    background: none !important;
    color: #fff;
    font-size: 18px;
    line-height: 44px;
    text-align: center;
  }
  button.pswp__button--outzoom {
    background-position: -132px 0;
  }
  button.pswp__button--inzoom {
    background-position: -88px 0;
  }
  button.pswp__button--copy {
    background: none !important;
    width: 60px;
    color: #fff;
  }
  .img-ocr-block {
    position: absolute;
    z-index: 10;
  }
  .img-ocr-p-item {
    position: absolute;
    white-space: nowrap;
  }
  .img-ocr-item {
    display: inline-block;
    position: relative;
    background-color: transparent;
    color: transparent;
    box-sizing: content-box;
    &::selection {
      color: transparent;
      background-color: rgba(66, 165, 245, 0.5);
    }
  }
  ::v-deep(.ant-message) {
    z-index: 2000;
  }
</style>
